import makeStyles from "@mui/styles/makeStyles";

import { calendarOccasionBackground } from "utils/relativeUtils";

export default makeStyles(
  (theme) => ({
    paper: {
      position: "relative",
      padding: [0, 20, 0, 20],
      overflow: "initial",
      color: theme.palette.common.white,
      minWidth: 255,
      minHeight: 100,
      width: "85%",
      backgroundColor: "white",
      [theme.breakpoints.up("tablet")]: {
        padding: [60, 80, 60, 80],
        width: "auto",
      },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "center",
      [theme.breakpoints.up("tablet")]: {
        flexDirection: "row",
        alignItems: "flex-start",
      },
    },
    closeButton: {
      transform: "translate(50%, -50%)",
    },
    info: {
      marginTop: 30,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      [theme.breakpoints.up("tablet")]: {
        maxWidth: 370,
        position: "relative",
      },
    },
    actions: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      [theme.breakpoints.up("tablet")]: {
        position: "relative",
        marginLeft: 100,
        padding: 0,
      },
    },
    video: {
      objectFit: "cover",
    },
    playerContainer: {
      overflow: "hidden",
      borderRadius: 10,
      boxShadow: "0px 0px 15px rgb(0 0 0 / 20%)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "auto",
      [theme.breakpoints.up("mobile")]: {
        width: 500,
        margin: "auto",
        maxWidth: 500,
      },
      [theme.breakpoints.up("tablet")]: {
        maxWidth: 500,
      },
    },
    playerActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: [15, 20],
      height: "auto",
      [theme.breakpoints.up("tablet")]: {
        height: "auto",
      },
    },
    textContent: {
      margin: [26, "auto"],
    },
    title: {
      marginBottom: 15,
    },
    text: {
      marginTop: 12,
    },
    buttons: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      margin: [15, "auto"],
      "@media screen and (max-height: 700px) and (max-width: 600px)": {
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
      },
      [theme.breakpoints.up("mobile")]: {
        flexDirection: "row",
        margin: [30, "auto"],
      },
    },
    button: {
      width: 190,
      [theme.breakpoints.up("mobile")]: {
        width: 240,
      },
      "@media screen and (max-height: 700px) and (max-width: 600px)": {
        fontSize: theme.typography.pxToRem(12),
        padding: [10, 5],
        margin: 0,
        width: 125,
      },
      margin: [5, 10],
    },
    buttonEdit: {
      display: "block",
      position: "relative",
      margin: 0,
      padding: 0,
      width: 61,
      height: 26,
      fontSize: theme.typography.pxToRem(12),
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
    buttonOrder: {
      order: 2,
      [theme.breakpoints.up("mobile")]: {
        order: 1,
      },
      "@media screen and (max-height: 700px) and (max-width: 600px)": {
        order: 1,
      },
    },
    schedule: {
      order: 1,
      [theme.breakpoints.up("mobile")]: {
        order: 2,
      },
      "@media screen and (max-height: 700px) and (max-width: 600px)": {
        order: 2,
      },
    },
    ...calendarOccasionBackground(theme),
  }),
  { name: "CalendarDetailModal" },
);
